__turbopack_context__.v({
  "actionItem": "accessibility-controls-module-scss-module__vzTiWW__actionItem",
  "actionsGrid": "accessibility-controls-module-scss-module__vzTiWW__actionsGrid",
  "arrowButton": "accessibility-controls-module-scss-module__vzTiWW__arrowButton",
  "arrowDown": "accessibility-controls-module-scss-module__vzTiWW__arrowDown",
  "arrowLeft": "accessibility-controls-module-scss-module__vzTiWW__arrowLeft",
  "arrowRight": "accessibility-controls-module-scss-module__vzTiWW__arrowRight",
  "arrowUp": "accessibility-controls-module-scss-module__vzTiWW__arrowUp",
  "container": "accessibility-controls-module-scss-module__vzTiWW__container",
  "controlButton": "accessibility-controls-module-scss-module__vzTiWW__controlButton",
  "infoArrow": "accessibility-controls-module-scss-module__vzTiWW__infoArrow",
  "infoPopover": "accessibility-controls-module-scss-module__vzTiWW__infoPopover",
  "infoSection": "accessibility-controls-module-scss-module__vzTiWW__infoSection",
  "infoSectionTitle": "accessibility-controls-module-scss-module__vzTiWW__infoSectionTitle",
  "infoTrigger": "accessibility-controls-module-scss-module__vzTiWW__infoTrigger",
  "textualAlternativeButton": "accessibility-controls-module-scss-module__vzTiWW__textualAlternativeButton",
  "zoomGroup": "accessibility-controls-module-scss-module__vzTiWW__zoomGroup",
  "zoomPercentage": "accessibility-controls-module-scss-module__vzTiWW__zoomPercentage",
});
